import type { ResponsiveImageProps } from "@ui/components/ResponsiveImage";
import { ResponsiveImage } from "@ui/components/ResponsiveImage";
import { RichText } from "@ui/eva-components/RichText";

import { LongArrowForwardIcon } from "@jti/brand-icons/long-arrow-forward";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import styles from "./FindStoreBanner.module.scss";

export type FindStoreBannerProps = {
  image: ResponsiveImageProps;
  text: string;
  link: string;
  renderImage?: (props: ResponsiveImageProps) => JSX.Element | null;
};

export const FindStoreBanner = ({ image, text, link, renderImage }: FindStoreBannerProps) => (
  <div className={styles.findStoreBanner}>
    <LinkBehaviour
      className={styles.link}
      href={link}
      onClick={() => dispatchTrackingEvent(TrackingEvents.TrackingStoreLocatorClick)}
    >
      <div className={styles.content}>
        <div className={styles.image}>{renderImage ? renderImage(image) : <ResponsiveImage {...image} />}</div>
        <div className={styles.textContainer}>
          <div className={styles.inner}>
            <RichText content={text} className={styles.text} />
            <LongArrowForwardIcon fill="#FFFFFF" />
          </div>
        </div>
      </div>
    </LinkBehaviour>
  </div>
);
